import React, { useEffect, useState } from 'react';

const Header = () => {
  /* Check for SSR, since window will not be available for a while untill JS is loaded */
  if (typeof window === 'undefined') {
    return <></>;
  }

  const [importedComponent, setImportedComponent] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const importComponent = async () => {
      /* Dynamically load MMT-UI-Header component for Bigger Screen Size ONLY */
      const module = await import('pwa-mmt-ui-header/ssr/header');
      const MMTHeaderComponent = module.Header;
      setImportedComponent(<MMTHeaderComponent selectedTabName={'Trains'} />);
    };

    !isSmallScreen && importComponent();
  }, [isSmallScreen]);

  useEffect(() => {
    const handleScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleScreenSize);

    return () => {
      window.removeEventListener('resize', handleScreenSize);
    };
  }, []);

  return <>{importedComponent}</>;
};

export default Header;
